import React, { useState } from 'react'
import { INFTHistory, INFTHistoryProps } from '../../../models/INFTHistory'
import { NFTHistoryWrapper, NFTHistoryFilter, NFTHistoryList } from './styled'
import { INFTHistoryFilter, NFTHistoryFilterList } from './NFTHistoryFilterList'
import NFTPagination from '../../../components/NFTPagination'
import { USER_PROFILE } from '../../../data/NFTMarketPerPages'
import NFTHistoryItem from './NFTHistoryItem'
import { useActiveWeb3React } from '../../../../../hooks'

export default function NFTHistory({ historyData, getUserAccountHistory }: INFTHistoryProps) {
  const { data, count } = historyData
  const [historyType, setHistoryType] = useState<string>('All')
  const [currentPage, setCurrentPage] = useState<number>(0)
  const perPage = USER_PROFILE.ACTIVITY
  const { chainId } = useActiveWeb3React()

  function ChangeHistoryType(type: string) {
    setHistoryType(type)
    setCurrentPage(0)
    getUserAccountHistory(type, 0)
  }

  function onPageChange(seletedItem: any) {
    const skip: number = seletedItem.selected * perPage
    setCurrentPage(seletedItem.selected)
    getUserAccountHistory(historyType, skip)
  }

  return (
    <NFTHistoryWrapper>
      <NFTHistoryFilter>
        <ul>
          <li className={`${historyType === 'All' ? 'active' : ''}`} onClick={() => ChangeHistoryType('All')}>
            All
          </li>
          {NFTHistoryFilterList.map((filterItem: INFTHistoryFilter) => (
            <li
              className={`${historyType === filterItem.key ? 'active' : ''}`}
              onClick={() => ChangeHistoryType(filterItem.key)}
              key={`${filterItem.key}_'FILTER`}
            >
              {filterItem.text}
            </li>
          ))}
        </ul>
      </NFTHistoryFilter>
      <NFTHistoryList>
        {data.map((item: INFTHistory) => (
          <NFTHistoryItem key={`${item.id}_HISTORY_ITEM`} historyItem={item} chainId={chainId} />
        ))}
      </NFTHistoryList>
      <NFTPagination pageCount={count} perPage={perPage} page={currentPage} pageChange={onPageChange} />
    </NFTHistoryWrapper>
  )
}
